import { useState } from 'react';
import { Columns, FoldPanel, Specimens, Textarea } from '@src/components';

const LONG_WISH = [
  'Anything with a bit of colour, please.',
  'I already have more mugs than shelves, so maybe not another mug.',
  'A good pair of wool socks would genuinely be the best thing here.',
].join('\n');

export function TextareaSection() {
  const [wish, setWish] = useState('Socks. Always socks.');
  const [growing, setGrowing] = useState(LONG_WISH);
  const [message, setMessage] = useState('Merry everything!');
  const [greeting, setGreeting] = useState('');

  return (
    <FoldPanel
      id="textareas"
      title="Textareas"
      hint="The same field shell as an input. Grows with its text instead of scrolling, without a line of JavaScript."
      example={`<Textarea
  label="Wish"
  value={wish}
  onValueChange={setWish}
  maxLength={120}
  showCount
  hint="Sent with the gift."
/>`}
    >
      <Specimens
        label="Autosize"
        note="Type into these — the field follows the text, and stops growing after twelve lines."
      >
        <Columns columns="fill" gap={5}>
          <Textarea
            label="Wish"
            value={wish}
            onValueChange={setWish}
            placeholder="What would you like?"
            hint="Starts at three rows and grows from there."
          />
          <Textarea
            label="Already long"
            value={growing}
            onValueChange={setGrowing}
            hint="Opened at the height of its content, with no flash of the wrong size."
          />
        </Columns>
      </Specimens>

      <Specimens
        label="Counter and limit"
        note="The count turns red at the limit, so a field that has stopped accepting text says why."
      >
        <Columns columns="fill" gap={5}>
          <Textarea
            label="Message"
            value={message}
            onValueChange={setMessage}
            maxLength={120}
            showCount
            hint="Sent with the gift."
          />
          <Textarea
            label="Greeting"
            value={greeting}
            onValueChange={setGreeting}
            maxLength={40}
            showCount
            error="Say something before sending."
            placeholder="A line or two"
          />
        </Columns>
      </Specimens>

      <Specimens label="Manual and disabled" note="autosize={false} restores the drag handle.">
        <Columns columns="fill" gap={5}>
          <Textarea
            label="Drag me taller"
            value=""
            onValueChange={() => {}}
            autosize={false}
            rows={2}
            placeholder="Fixed at two rows until you resize it"
            hint="autosize={false} — resizable, and scrolls once it is full."
          />
          <Textarea
            label="Disabled"
            value="Locked while the game is archived."
            onValueChange={() => {}}
            disabled
            hint="Archived games are read-only."
          />
        </Columns>
      </Specimens>
    </FoldPanel>
  );
}
